import { ElementStyles, ViewTemplate } from '@microsoft/fast-element';
import { logger } from '../utils';
/**
 * @param token - A module export token.
 * @public
 */
export function isAppMetadata(token) {
    const metadata = token;
    return metadata && !!metadata.name && !!metadata.version;
}
/**
 * @param token - A module export token.
 * @public
 */
export function isAppRegistration(token) {
    return typeof token === 'function'; // && token.length === 1; // < could enforce context arg
}
/**
 * @param token - A module export token.
 * @public
 */
export function isAppRoute(token) {
    const route = token;
    return route && !!route.path && !!route.element;
}
/**
 * @param token - A module export token.
 * @public
 */
export function isAppStore(token) {
    const store = token;
    return store && !!store.store;
}
/**
 * @param token - A module export token.
 * @public
 */
export function isAppElement(token) {
    const pbcElements = token;
    return (pbcElements &&
        !!pbcElements.targetId &&
        !!pbcElements.elements &&
        isViewTemplate(pbcElements.elements));
}
/**
 * @param token - A module export token / element candidate.
 * @public
 */
export function isViewTemplate(token) {
    return token instanceof ViewTemplate;
}
/**
 * @param token - A module export token.
 * @public
 */
export function isAppStyle(token) {
    const pbcStyles = token;
    return (pbcStyles && !!pbcStyles.targetId && !!pbcStyles.styles && isComposableStyles(pbcStyles.styles));
}
/**
 * @param token - A module export token / styles candidate.
 * @public
 */
export function isComposableStyles(token) {
    return (typeof token === 'string' || token instanceof ElementStyles || token instanceof CSSStyleSheet);
}
/**
 * @public
 */
export const registrationPredicate = (asset, predicate, context) => (typeof predicate === 'function' ? predicate(asset, context) : true);
/**
 * @public
 */
export const targetIdPredicate = (asset, targetId) => Array.isArray(targetId) ? targetId.includes(asset.targetId) : asset.targetId === targetId;
/**
 * @public
 */
export const assetPredicate = (asset, context) => typeof asset.predicate === 'function' ? asset.predicate(context) : true;
/**
 * @param module - An imported module.
 * @param predicate - Token type predicate.
 * @public
 */
export const getQualifiedModuleTokens = (module, predicate) => {
    const tokenArray = [];
    Object.keys(module).forEach((token) => {
        /**
         * Guard against `export default` tokens that can cause duplicates
         */
        if (tokenArray.includes(module[token])) {
            return;
        }
        /**
         * Guard against tokens of unexpected types
         */
        if (predicate && !predicate(module[token])) {
            logger.debug(`The module export ${token} is not of the expected type.`);
            return;
        }
        tokenArray.push(module[token]);
    });
    return tokenArray;
};
